var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":this.$appName}})]),_vm._m(0),_vm._m(1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"subtitle"},[_c('i',[_vm._v("Powered by")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("Vue.js")]),_c('li',[_vm._v("Azure")]),_c('li',[_vm._v("Netlify")]),_c('li',[_vm._v("Buefy")])])
}]

export { render, staticRenderFns }